import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LoggedUserService {
  private readonly url = `${environment.apiUrl}`;
  private userSubject = new BehaviorSubject<LoggedUserData | null>(null);
  private userRequest$: Observable<LoggedUserData> | null = null;

  constructor(private http: HttpClient) { }

  getUser(): Observable<LoggedUserData> {
    if (this.userSubject.value) {
      // Return loaded user data
      return of(this.userSubject.value);
    }

    if (!this.userRequest$) {
      // Api call to return user data
      this.userRequest$ = this.getUserDataApiCall().pipe(
        tap(u => this.userSubject.next(u)),
        shareReplay(1)
      );
    }
    return this.userRequest$;
  }

  logoutUser() {
    this.userSubject.next(null);
    this.userRequest$ = null;
  }

  reloadUser(): Observable<LoggedUserData> {
    this.userRequest$ = null;
    return this.getUserDataApiCall().pipe(
      tap(user => this.userSubject.next(user))
    );
  }

  private getUserDataApiCall(): Observable<LoggedUserData> {
    return this.http.get<LoggedUserData>(`${this.url}user/me`);
  }
}

export interface LoggedUserData {
  username: string;
  email: string;
  authorities?: string[];
  readOnlyScreens?: string[];
  allowOpNoInsurance?: boolean;
}
